import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.MANAGEMENT)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: {
                title: "management",
                to: APP_ROUTES_TO.MANAGEMENT_PHONE_NUMBERS,
            },
            title: "management",
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function RouteComponent() {
    return <Outlet />;
}
